import { selectLoadingComplete, useAppSelector } from '@aorg/store';
import { useMemo, useRef, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
// AuthHeader keeps the Home / Resources / Network / Profile menu version
import AppHeader from '../components/AppHeader';
import CommingSoonDialog from '../components/CommingSoonDialog';
import LoadingDialog from '../components/LoadingDialog';
import OpenAppSheetMini from '../components/OpenAppSheetMini';
import AorgScrollView from '../components/AorgScrollView';
import Footer from '../components/layout/Footer';

function AuthLayout() {
  const [comminSoonIsOpen, setComminSoonIsOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <AorgScrollView>
      {pathname === '/' && <LoadingDialog />}

      <AppHeader />
      <main className="flex flex-col flex-1 bg-black min-h-full">
        <Outlet />
      </main>

      {(pathname === '/' ||
        pathname === '/resources' ||
        pathname === '/network' ||
        pathname === '/profile') && <Footer />}

      <CommingSoonDialog
        isOpen={comminSoonIsOpen}
        onClose={() => setComminSoonIsOpen(false)}
      />

      <OpenAppSheetMini />
    </AorgScrollView>
  );
}

export default AuthLayout;
